<table mat-table [dataSource]="dataSource" class="file-overview-table">
    <!-- icon -->
    <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef class="file-overview-header "></th>

        <td mat-cell *matCellDef="let row" class="file-overview-row file-overview-icon-cell ">
            @if (row.icon) {
                @if (isIconUrl(row.icon)) {
                    <img [src]="row.icon" alt="" class="file-overview-icon" />
                } @else {
                    <i [class]="row.icon" aria-hidden="true"></i>
                }
            }
        </td>
    </ng-container>

    <!-- file name -->
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="file-overview-header ">
            {{ 'FILE_OVERVIEW_TABLE.NAME' | translate }}
        </th>

        <td mat-cell *matCellDef="let row" class="file-overview-row">
            {{ row.name }}
        </td>
    </ng-container>

    <!-- course -->
    <ng-container matColumnDef="course">
        <th mat-header-cell *matHeaderCellDef class="file-overview-header ">
            {{ 'FILE_OVERVIEW_TABLE.COURSE' | translate }}
        </th>

        <td mat-cell *matCellDef="let row" class="file-overview-row">
            {{ row.course }}
        </td>
    </ng-container>

    <!-- file size -->
    <ng-container matColumnDef="size">
        <th mat-header-cell *matHeaderCellDef class="file-overview-header ">
            {{ 'FILE_OVERVIEW_TABLE.SIZE' | translate }}
        </th>

        <td mat-cell *matCellDef="let row" class="file-overview-row">
            {{ row.size }}
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnNames; sticky: true"></tr>
    <tr
        mat-row
        *matRowDef="let row; columns: columnNames"
        class="file-overview-row"
        tabindex="0"
        [attr.aria-selected]="selectedRowId === row.id"
        [class.file-overview-row--selected]="selectedRowId === row.id"
        (click)="onRowClick(row.id)"
        (keydown.enter)="onRowClick(row.id)"
        (keydown.space)="onRowClick(row.id)">
    </tr>
</table>